const state = {
    user:{}
}
const mutations = {
    updateUser(state,user){
        state.user = user
    }
}
const actions = {
    
}

export default{
    namespaced: true,
    state,
    mutations,
    actions
}